import * as React from 'react'
import { Link, LINK_APPEARANCE_INLINE, SIZE_SMALL } from '@mds/mds-reactjs-library'
import styled from 'styled-components'

const bemComponentName = 'footer'

const needHelp = `${bemComponentName}__needHelp`
const linksGroup = `${bemComponentName}__linksGroup`
const privacyPolicy = `${bemComponentName}__privacyPolicy`
const versionText = `${bemComponentName}__version`
const link = `${bemComponentName}__link`

const Wrapper = styled.footer`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: auto;
  margin: 0 1rem;
  padding: 16px 28px;
  box-sizing: border-box;
  text-align: left;
  font-family: 'McKinsey Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  text-shadow: ${
    /* istanbul ignore next */
    (props) => props.theme.footerTextShadow || 'none'
  };

  .${needHelp} {
    padding: 2px;
  }

  .${linksGroup} {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }

  .${needHelp}, .${linksGroup}, .${privacyPolicy}, .${versionText}, .${link}, .mds-inline-link,
  .mds-block-link,
  .mds-small,
  a,
  span {
    font-family: 'McKinsey Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .${versionText} {
    color: #757575;
  }

  .mds-inline-link,
  .mds-block-link,
  .mds-small,
  a {
    color: #051c2c;
    text-decoration: underline;
  }

  @media (max-width: 600px) {
    justify-content: center;
    text-align: center;

    .${linksGroup} {
      justify-content: center;
    }
  }
`

type FooterProps = {
  version: string
}

function Footer({ version }: FooterProps) {
  return (
    <Wrapper>
      <section className={needHelp}>
        <Link className={link} appearance={LINK_APPEARANCE_INLINE} size={SIZE_SMALL} href="/help">
          Need help?
        </Link>
      </section>
      <div className={linksGroup}>
        <span className={privacyPolicy}>
          <Link
            className={link}
            appearance={LINK_APPEARANCE_INLINE}
            size={SIZE_SMALL}
            href="https://www.mckinsey.com/solutions-privacy-statement"
          >
            Privacy policy
          </Link>
        </span>
        <span className={versionText}>{version}</span>
      </div>
    </Wrapper>
  )
}

export default Footer
